/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function(event) {
    numerically_ignore_letters = function(a,b){
        var non_digits = '^a-zA-Z';
        var a_val = parseInt($('label', a).text().replace(non_digits, ''), 10 );
        var b_val = parseInt( $('label', b).text().replace(non_digits, ''), 10 );
        return  a_val - b_val;
    }

    sort_filters_ignore_letters = function () {
        $('.collection__filter-checkbox-list').each( function() {
            $(this).children('li').sort(numerically_ignore_letters).prependTo($(this));
        });
    }

    sort_filters_ignore_letters();
});

if (navigator.userAgent.indexOf('Mac OS X') != -1) {
    console.log("Mac"); // You can do whatever here
} else {
    current = window.location.pathname;
    if (current == '/') {
        setTimeout(function(){
            $('.loox-rating').addClass('win');
        }, 3000)
        
    } else {
        $('.loox-rating').addClass('win');
    }
    
    console.log("Windows"); // You can do whatever here
}
